import CodeBlock from './CodeBlock';
import type { Endpoint } from '@/mocks/docs';

const methodStyles: Record<Endpoint['method'], string> = {
  POST: 'bg-primary-500 text-background-50',
  GET: 'bg-accent-500 text-background-50',
};

interface EndpointCardProps {
  endpoint: Endpoint;
}

export default function EndpointCard({ endpoint }: EndpointCardProps) {
  return (
    <article id={endpoint.id} className="scroll-mt-24">
      <div className="flex flex-wrap items-center gap-3">
        <span
          className={`inline-flex items-center text-xs font-bold px-2.5 py-1 rounded-md uppercase tracking-wide ${methodStyles[endpoint.method]}`}
        >
          {endpoint.method}
        </span>
        <code className="font-mono text-sm text-foreground-900">{endpoint.path}</code>
      </div>

      <h3 className="mt-3 font-heading font-semibold text-lg text-foreground-950">{endpoint.title}</h3>
      <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{endpoint.summary}</p>

      <div className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
        <i className="ri-key-2-line"></i>
        <span>
          Auth: <span className="font-mono text-foreground-700">{endpoint.auth}</span>
        </span>
      </div>

      {endpoint.request && (
        <div className="mt-5 flex flex-col gap-2">
          <h4 className="text-sm font-semibold text-foreground-900">Request body</h4>
          <CodeBlock code={endpoint.request} language="json" title="request.json" />
        </div>
      )}

      <div className="mt-5 flex flex-col gap-2">
        <h4 className="text-sm font-semibold text-foreground-900">Response</h4>
        <CodeBlock code={endpoint.response} language="json" title="response.json" />
      </div>

      <div className="mt-5 grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="flex flex-col gap-2 min-w-0">
          <h4 className="text-sm font-semibold text-foreground-900">cURL</h4>
          <CodeBlock code={endpoint.curl} language="bash" title="terminal" />
        </div>
        <div className="flex flex-col gap-2 min-w-0">
          <h4 className="text-sm font-semibold text-foreground-900">JavaScript</h4>
          <CodeBlock code={endpoint.js} language="javascript" title="fetch.js" />
        </div>
      </div>
    </article>
  );
}